import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import CardRegistrationForm from './CardRegistrationForm';
import apiClient from '@/lib/apiClient';
import { toast } from 'sonner';

type PaymentProvider = 'fincode' | 'gmo_pg';

interface CardRegistrationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  paymentProvider?: PaymentProvider;
  /** GMO PG の場合に使用する Shop ID（API から取得） */
  gmoPgShopId?: string;
  /** 決済テストモード（true: テスト環境を使用） */
  testMode?: boolean;
}

const CardRegistrationDialog: React.FC<CardRegistrationDialogProps> = ({
  isOpen,
  onClose,
  onSuccess,
  paymentProvider = 'fincode',
  gmoPgShopId,
  testMode = false
}) => {
  const [loading, setLoading] = useState(false);

  const handleTokenCreated = async (token: string) => {
    setLoading(true);
    try {
      await apiClient.post('/customer/payment_methods', {
        card_token: token
      });

      toast.success('カードを登録しました');
      onSuccess();
      onClose();
    } catch (error: any) {
      console.error('Card registration error:', error);
      const errorMessage = error.response?.data?.error || 'カードの登録に失敗しました';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>新しいカードを登録</DialogTitle>
          <DialogDescription>
            クレジットカード情報を入力してください
          </DialogDescription>
        </DialogHeader>

        <CardRegistrationForm
          onSuccess={handleTokenCreated}
          onCancel={onClose}
          loading={loading}
          paymentProvider={paymentProvider}
          gmoPgShopId={gmoPgShopId}
          testMode={testMode}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CardRegistrationDialog;
